import { Spinner as SpinnerBootstrap } from 'react-bootstrap';

export const Spinner = ({size = 'md'}) => (
    <SpinnerBootstrap animation="border" variant="warning" size={size}>
        <span className="visually-hidden">Loading...</span>
    </SpinnerBootstrap>
);